<template>
  <button
    class="button-reset"
    aria-label="Réinitialiser"
    type="button"
    @click="(e) => emit('click', e)"
  >
    <icon name="cross" />
  </button>
</template>
<script setup lang="ts">
const emit = defineEmits(["click"]);
</script>
<style lang="scss" scoped>
.button-reset {
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 100%;
  .icon {
    border: var(--stroke_thickness_l) solid var(--color_neutral_200);
    border-radius: 50%;
    color: var(--color_neutral_200);
  }
  &:hover,
  &:focus {
    .icon {
      border: var(--stroke_thickness_l) solid var(--color_error);
      color: var(--color_error);
    }
  }
}
</style>
